import { createContext } from 'react';
export const PromotionContext = createContext(null);
